import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=5380bf16&scoped=true&"
import script from "./GiftList.vue?vue&type=script&lang=js&"
export * from "./GiftList.vue?vue&type=script&lang=js&"
import style0 from "./GiftList.vue?vue&type=style&index=0&id=5380bf16&lang=scss&scoped=true&"
import style1 from "./GiftList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5380bf16",
  null
  
)

export default component.exports